import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router'

import Details from '../components/Details'

@inject('guidedTour', 'message')
@observer
class DetailsContainer extends Component {

  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]),
    guidedTour: PropTypes.object.isRequired,
    message: PropTypes.object.isRequired,
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
    router: PropTypes.shape({
      goBack: PropTypes.func.isRequired,
    }).isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      messageError: null
    }
  }

  componentWillMount() {
    const { params: { id }, guidedTour } = this.props
    guidedTour.openById(id * 1)
  }

  @autobind
  handleClose() {
    this.props.router.goBack()
  }

  @autobind
  handleSendMessage({ target: { value } }) {
    this.props.message.send(value)
      .then(() => {
        this.setState({
          messageError: null,
        })
        this.handleClose()
      })
      .catch((ex) => {
        this.setState({
          messageError: JSON.stringify(ex.errors)
        })
      })
  }

  render() {
    const {
      guidedTour,
      guidedTour: { current },
      params: { id }
    } = this.props

    if (guidedTour.loading) {
      return <div>Führung wird geladen</div>
    }

    if (!current || current.id !== id * 1) {
      return <div>Führung nicht gefunden!</div>
    }

    return (
      <Details
        current={current}
        onSendMessage={this.handleSendMessage}
        messageError={this.state.messageError}
      />
    )
  }
}

const DetailsContainerWithRouter = withRouter(DetailsContainer)

export { DetailsContainerWithRouter as default }



// WEBPACK FOOTER //
// ./src/guided-tour/containers/Details.js